import { Collapse } from "antd";
import React from "react";
import { FAQResponse } from "../api/types/FAQ";
import arrowDown from "../assets/arrow-down.svg";

const { Panel } = Collapse;

type FAQSectionProps = {
  data: FAQResponse | undefined;
};

const FAQSection: React.FC<FAQSectionProps> = ({ data }) => {
  // Todo add loaders or errors
  return data ? (
    <div className="font-nunito w-full h-full  bg-primary-card rounded-lg p-8 text-start">
      <h2 className="faq-header text-white text-4xl font-semibold my-12">
        FAQ
      </h2>
      <Collapse
        expandIconPosition="right"
        className="text-white border-none bg-transparent"
        expandIcon={({ isActive }) => (
          <div className="w-[56px] h-[56px] p-3 bg-[#3F51B5] rounded-xl flex items-center justify-center">
            <img
              src={arrowDown}
              alt="arrow"
              className={`transition-transform duration-300 ${
                isActive ? "transform rotate-180" : ""
              }`}
            />
          </div>
        )}
      >
        {data.data.map((faq) => (
          <Panel
            header={
              <span
                className="text-2xl md:text-3xl text-white"
                dangerouslySetInnerHTML={{ __html: faq.question }}
              />
            }
            key={faq.id.value}
            className="p-0"
            style={{
              borderBottom: "1px solid #3f51b5",
              borderRadius: "0",
            }}
          >
            <p
              className="faq-answer text-base md:text-xl text-white bg-primary-card"
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          </Panel>
        ))}
      </Collapse>
    </div>
  ) : null;
};

export default FAQSection;
